import React, { useImperativeHandle, useState } from "react";
import PageReviewExam, { UrlParams } from "../../../../../reviewExam";
import styles from "./index.module.scss";
import html2PDF from "jspdf-html2canvas";
import { sleep } from "utils/common";
import {
    getFilesFromSelector,
    getImagesFromSelector
} from "../../../../../../../service/dom";

export interface ExamPDFInstance {
    load(params: UrlParams): Promise<void>;
    getBlob(): Promise<Blob>;
    getFiles(): string[];
}

export const ExamPDF = React.forwardRef<ExamPDFInstance>((_, ref) => {
    const [params, setParams] = useState<UrlParams>();

    useImperativeHandle(ref, () => ({
        load,
        getBlob,
        getFiles
    }));

    async function load(params: UrlParams) {
        // 先释放之前的试卷, 这样才能用过dom来判断新试卷是否加载完毕
        setParams(undefined);
        await sleep(0);
        setParams(params);
        await waitUntilLoaded();
    }

    async function waitUntilLoaded() {
        let count = 0;
        const selector = `.${styles.root} [class^=reviewExam_block]`;

        while (true) {
            if (document.querySelectorAll(selector).length !== 0) return;
            await sleep(1000);
            count++;
            if (count > 10) throw new Error("试题加载超时");
        }
    }

    async function getBlob() {
        const wrapper: any = document.querySelector(
            `.${styles.root} [class^='HomeworkLayout_main']`
        );
        if (!wrapper) throw new Error("加载试卷出错");

        const pdf = await html2PDF(wrapper, {
            html2canvas: { useCORS: true, imageTimeout: 5 * 60 * 1000 },
            success: () => {}
        });

        return pdf.output("blob");
    }

    function getFiles() {
        const files = getFilesFromSelector(
            "[class^=QuestZhuguan_content].globalISROOTS"
        );

        const images1 = getImagesFromSelector(
            "[class^=QuestZhuguan_content].globalISROOTS"
        );

        const images2 = getImagesFromSelector("[class^=FilesList_listWrapper]");

        return [...files, ...images1, ...images2];
    }

    return (
        <div className={styles.root}>
            {params && <PageReviewExam match={{ params }} />}
        </div>
    );
});
